
import React, {Component} from 'react';
import {Modal,FormControl,Button,ButtonToolbar,Row,Col,FormGroup,Form,ControlLabel} from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import { SliderPicker } from 'react-color';
import WorkdocStore from '../../stores/WorkdocStore'

var NotificationSystem = require('react-notification-system');
class SWTNewColorModal extends Component {

  constructor(...args){
    super(...args)

    this.state = ({colorName:"",colorDefault:"#fff"})
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    
  }

  openPopup() {

  }

  handleChangeComplete(color) {
    this.setState({colorDefault:color.hex})
  }

  onNameChange(e) {
    this.setState({colorName:e.target.value})
  }

  onSaveClick() {
    let {colorName,colorDefault} = this.state
    let postData = {name:colorName,hex:colorDefault}
    let that = this
    WorkdocStore.saveCarColor(postData,function(result){                  
      if(that.props.onChange!==undefined){
        that.props.onChange(postData);
      }
      that.props.onHide(false);
    },function(){
      that._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีข้อผิดพลาดในการบันทึกสี' + colorName + ' ลองใหม่',
        level: 'error',
        position: 'tc',        
      });
    })
  }

  renderNewColor() {
    let {colorName,colorDefault} = this.state
    return(
      <div>
        <Form horizontal>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              เลือกสี
            </Col>
            <Col sm={7}>
              <SliderPicker 
                color={colorDefault}
                onChangeComplete={this.handleChangeComplete.bind(this)}
              >
              </SliderPicker>
            </Col>
          </FormGroup>
          <FormGroup>
            <Col componentClass={ControlLabel} sm={3}>
              ตั้งชื่อสี
            </Col>
            <Col sm={7}>
              <FormControl
                value={colorName}
                onChange={this.onNameChange.bind(this)}
              >
              </FormControl>
            </Col>
          </FormGroup>
        </Form>
      </div>  
    )
  }

  onHide() {
    this.props.onHide(false)
  }

  renderButton() {
    return(
      <div>
        <Button className="btn btn-primary" onClick={this.onSaveClick.bind(this)}>
          <FontAwesome name="save" />&nbsp;บันทึก
        </Button>
        <Button className="btn btn-default" onClick={this.onHide.bind(this)}>
          <FontAwesome name="remove" />&nbsp;ปิด
        </Button>
      </div>
    )
  }

  render(){
    let {show} = this.props

    return (
      <Modal show={show} enforceFocus={false} onHide={this.props.onHide} dialogClassName="midwidth-dialog">
        <Modal.Header closeButton>
          <Modal.Title>{'เพิ่มสีรถ'}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {this.renderNewColor()}
            <NotificationSystem ref="notificationSystem" />            
        </Modal.Body>
        <Modal.Footer>
          {this.renderButton()}
        </Modal.Footer>
      </Modal>
    )
  }
}


export default SWTNewColorModal;





// WEBPACK FOOTER //
// ./src/view/workdoc/SWTNewColorModal.js